export default __webpack_public_path__ + "static/media/361.8c88641c.png";